import { productTypeToReflexive } from '@hc-frontend/core-types-transformers';
import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';
import {
  LeadProductRequestDto,
  saveAction,
  SaveActionDtoActionType,
  updateLeadProduct,
} from '@hc-frontend/services';

import type { LeadProductOptions } from '../../domain';
import type { JourneyRepository } from '../../domain/repositories/journey-repository';

export type JourneyAdapterOptions = {
  baseUrl: string;
};

function mapLeadProductEntityToDto(
  parameters: LeadProductOptions,
): LeadProductRequestDto {
  return {
    domain_session_id: parameters.domainSessionId,
    user_id: parameters.userId,
    current_product_type: productTypeToReflexive(parameters.currentProductType),
    new_product_type: productTypeToReflexive(parameters.newProductType),
  };
}

/**
 * @deprecated - Use adapter per plate
 */
export function journeyAdapterFactory(
  options: JourneyAdapterOptions,
): Pick<JourneyRepository, 'updateLeadProduct' | 'saveAction'> {
  return {
    updateLeadProduct: async (parameters) => {
      try {
        const payload = mapLeadProductEntityToDto(parameters);

        const result = await updateLeadProduct(options.baseUrl, payload);

        if (result.result !== 'success') {
          throw new Error(
            `Error saving user's visit with code ${result.status}`,
          );
        }

        return createSuccessOperationResult(undefined);
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToUpdateLeadProduct',
              rootCause: error as Error,
            },
          ],
        });
      }
    },

    async saveAction(userId, domainSessionId, product) {
      try {
        const result = await saveAction(options.baseUrl, {
          user_id: userId,
          domain_session_id: domainSessionId,
          product,
          action_type_id: SaveActionDtoActionType.LEAD_SUBMITTED,
        });

        if (result.result !== 'success') {
          throw new Error(`Error saving action with code ${result.status}`);
        }

        return createSuccessOperationResult(undefined);
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            {
              code: 'failedToSaveAction',
              rootCause: error as Error,
            },
          ],
        });
      }
    },
  };
}
